<style src="./ModalZoom.scss" lang="scss"></style>
<template>
  <section class="ModalZoom">
    <img
      class="stickedPhoto"
      :src="photo"
      alt="foto grudada"
      :style="{
        'object-position': `${zoom.thumb.left}% ${zoom.thumb.top}%`,
      }"
      @click="stickPhoto(false)"
      ref="mainPhoto"
      v-if="showStickedPhoto"
    />
    <img
      class="photo"
      :src="photo"
      alt="foto"
      @mousemove="mouseMove"
      ref="mainPhoto"
      v-if="!showStickedPhoto"
    />
    <template v-if="!showStickedPhoto">
      <div
        class="mask"
        :style="{ left: `${zoom.mask.left}px`, top: `${zoom.mask.top}px` }"
      ></div>

      <img
        class="zoom"
        :src="photo"
        alt="zoom"
        :style="{
          'object-position': `${zoom.thumb.left}% ${zoom.thumb.top}%`,
        }"
      />
    </template>
  </section>
</template>

<script>
export default {
  props: {
    photo: {
      default: '',
    },
  },
  data() {
    return {
      showStickedPhoto: false,
      zoom: {
        thumb: {
          left: 0,
          top: 0,
        },
        mask: {
          left: 0,
          top: 0,
        },
      },
    };
  },
  methods: {
    mouseMove(event) {
      const maskSize = 50;

      const mouseX = event.offsetX;
      const mouseY = event.offsetY;

      const maskLeftPos = mouseX - maskSize;
      const maskTopPos = mouseY - maskSize;

      this.zoom.mask.left = maskLeftPos;
      this.zoom.mask.top = maskTopPos;

      const imageWidth = this.$refs.mainPhoto.clientWidth;
      const imageHeight = this.$refs.mainPhoto.clientHeight;

      const thumbLeftPos = (100 * mouseX) / imageWidth;
      const thumbTopPos = (100 * mouseY) / imageHeight;

      this.zoom.thumb.left = thumbLeftPos;
      this.zoom.thumb.top = thumbTopPos;
    },
  }
};
</script>
